
import { defineComponent } from 'vue';
import { ApiPlantResponseMasonry } from '@/@types/plant';

import PlantCard from '@/components/PlantCard.vue';

export default defineComponent({
  name: 'PlantsGrid',

  components: {
    PlantCard,
  },

  props: {
    plants: {
      type: Array as () => ApiPlantResponseMasonry[],
      required: true,
    },
    masonry: {
      type: Boolean,
      default: false,
    },
    amplitudeKey: {
      type: String,
      default: null,
    },
  },
});
